<template>
  <el-table-column
    prop="order_numbers"
    sortable="custom"
    label="Megdendelésszám"
    show-overflow-tooltip
    min-width="170"
  >
    <template slot-scope="scope">
      {{ scope.row.order_numbers }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'order_numbers',
};
</script>
